import * as api from '../api/index'

import { FETCH_ALL, ADD_NEW, UPDATE, DELETE } from '../actions/constant'

export const getSpecies = () => async (dispatch)=> {
    try {
        const { data } = await api.fetchSpecies()
        dispatch({ type: FETCH_ALL, payload: data })
    } catch (error) {
        console.log(error)
    }
}

export const addNewSpecies =(species) => async (dispatch) => {
    try {
        const { data } = await api.addSpecies(species)
        dispatch({ type: ADD_NEW, payload: data })
    } catch (error) {
        console.log(error.response)
    }
}

export const updateSpecies =(id, species) => async (dispatch) => {

    const { data } = await api.updateSpecies(id, species)
    dispatch({ type: UPDATE, payload: data })
    try {
        
    } catch (error) {
        console.log(error)
    }
}

export const deleteSpecies =(id) => async (dispatch) => {
    try {
        await api.deleteSpecies(id)

        dispatch({type: DELETE, payload: id})
    } catch (error) {
        console.log(error)
    }
}